module.exports = __webpack_public_path__ + "img/sunset-3.d5311890.jpg";